"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _Dialog = _interopRequireDefault(require("@eig-builder/core-ui/Dialog"));

var _DialogActions = _interopRequireDefault(require("@eig-builder/core-ui/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@eig-builder/core-ui/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@eig-builder/core-ui/DialogTitle"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Tooltip = _interopRequireDefault(require("@eig-builder/core-ui/Tooltip"));

var _columnRenderer = require("./column-renderer");

var _styles = require("@eig-builder/core-ui/styles");

require("../lang");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    columnSelector: {
      margin: "0",
      padding: "4px 0",
      listStyle: "none",
      minWidth: "550px",
      "& .first-column, & .second-column": {
        width: "50%",
        display: "inline-block",
        verticalAlign: "top"
      },
      "& .column-selector-container": {
        padding: "4px 0",
        "& .column-selector-check": {
          padding: "0",
          "float": "left",
          marginTop: "-5px"
        },
        "& .label": {
          cursor: "pointer",
          marginBottom: "0",
          paddingLeft: "8px",
          verticalAlign: "middle"
        }
      }
    },
    columnBtn: {
      display: "inline-block",
      transition: "background-color $short-animation-time ease-in-out",
      "& .icon": {
        color: "$primitive-text-secondary !important",
        verticalAlign: "baseline"
      },
      "& .active": {
        backgroundColor: "$navbar-active-background-color"
      },
      "&:hover": {
        "& .icon": {
          color: "$primitive-text-primary !important"
        },
        backgroundColor: "$navbar-active-background-color",
        cursor: "pointer"
      }
    }
  };
});

var ColumnSelector = function ColumnSelector(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      columnSelectorOpen = _useState2[0],
      setColumnSelectorOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      canceledSelector = _useState4[0],
      setCanceledSelector = _useState4[1];

  var _useState5 = (0, _react.useState)(props.headers),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      localHeaders = _useState6[0],
      setLocalHeaders = _useState6[1];

  (0, _react.useEffect)(function () {
    setLocalHeaders(props.headers);
  }, []);
  (0, _react.useEffect)(function () {
    if (canceledSelector) {
      setColumnSelectorOpen(false);
      setLocalHeaders(props.headers);
      setCanceledSelector(false);
    }
  }, [canceledSelector]);

  var toggleColumnSelector = function toggleColumnSelector() {
    return setColumnSelectorOpen(!columnSelectorOpen);
  };

  var applyColumnSelection = function applyColumnSelection() {
    props.setHeaders(localHeaders);
    toggleColumnSelector();
  };

  var cancelColumnSelection = function cancelColumnSelection() {
    setCanceledSelector(true);
  };

  var onClick = function onClick(headers) {
    setLocalHeaders(headers);
  };

  var columnTag = 'column-button-' + props.tag;
  var hideColumnSelector = props.hideColumnSelector,
      tooltip = props.tooltip;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: columnSelectorOpen
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.title"
  })), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.subTitle"
  }), /*#__PURE__*/_react["default"].createElement("ul", {
    className: classes.columnSelector
  }, (0, _columnRenderer.renderColumnSelector)(localHeaders, onClick, props.tag))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    size: "large",
    onClick: cancelColumnSelection,
    tag: 'cancel-edit-columns-' + props.tag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: 'cancel-edit-columns-' + props.tag,
    dataElementId: 'cancel-edit-columns-' + props.tag
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.cancelBtn"
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    size: "large",
    tag: 'submit-edit-columns-' + props.tag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: 'submit-edit-columns-' + props.tag,
    dataElementId: 'submit-edit-columns-' + props.tag,
    onClick: applyColumnSelection
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "core.components.datatable.columnSelector.primaryBtn"
  })))), !hideColumnSelector && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip.text,
    placement: "top",
    className: classes.columnBtn
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: toggleColumnSelector,
    tag: columnTag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: columnTag,
    dataElementId: columnTag
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "view_column",
    tag: 'column-button-icon-' + props.tag
  })))));
};

var _default = ColumnSelector;
exports["default"] = _default;
ColumnSelector.propTypes = {
  tag: _propTypes["default"].string,
  hideColumnSelector: _propTypes["default"].bool,
  tooltip: _propTypes["default"].object,
  headers: _propTypes["default"].array.isRequired,
  setHeaders: _propTypes["default"].func.isRequired
};